import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type InsertRouteTemplateMutationVariables = Types.Exact<{
  template: Types.Route_Templates_Insert_Input;
}>;


export type InsertRouteTemplateMutation = { __typename?: 'mutation_root', insert_route_templates_one?: { __typename?: 'route_templates', id: number, name: string, stops: object } | null };

export type UpdateRouteTemplateMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
  set: Types.Route_Templates_Set_Input;
}>;


export type UpdateRouteTemplateMutation = { __typename?: 'mutation_root', update_route_templates_by_pk?: { __typename?: 'route_templates', id: number, name: string, stops: object, updated_at: string } | null };

export type DeleteRouteTemplateMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
}>;


export type DeleteRouteTemplateMutation = { __typename?: 'mutation_root', delete_route_templates_by_pk?: { __typename?: 'route_templates', id: number } | null };


export const InsertRouteTemplateDocument = gql`
    mutation insertRouteTemplate($template: route_templates_insert_input!) {
  insert_route_templates_one(object: $template) {
    id
    name
    stops
  }
}
    `;
export type InsertRouteTemplateMutationFn = Apollo.MutationFunction<InsertRouteTemplateMutation, InsertRouteTemplateMutationVariables>;

/**
 * __useInsertRouteTemplateMutation__
 *
 * To run a mutation, you first call `useInsertRouteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertRouteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertRouteTemplateMutation, { data, loading, error }] = useInsertRouteTemplateMutation({
 *   variables: {
 *      template: // value for 'template'
 *   },
 * });
 */
export function useInsertRouteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<InsertRouteTemplateMutation, InsertRouteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertRouteTemplateMutation, InsertRouteTemplateMutationVariables>(InsertRouteTemplateDocument, options);
      }
export type InsertRouteTemplateMutationHookResult = ReturnType<typeof useInsertRouteTemplateMutation>;
export type InsertRouteTemplateMutationResult = Apollo.MutationResult<InsertRouteTemplateMutation>;
export type InsertRouteTemplateMutationOptions = Apollo.BaseMutationOptions<InsertRouteTemplateMutation, InsertRouteTemplateMutationVariables>;
export const UpdateRouteTemplateDocument = gql`
    mutation updateRouteTemplate($id: bigint!, $set: route_templates_set_input!) {
  update_route_templates_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
    name
    stops
    updated_at
  }
}
    `;
export type UpdateRouteTemplateMutationFn = Apollo.MutationFunction<UpdateRouteTemplateMutation, UpdateRouteTemplateMutationVariables>;

/**
 * __useUpdateRouteTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateRouteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRouteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRouteTemplateMutation, { data, loading, error }] = useUpdateRouteTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateRouteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRouteTemplateMutation, UpdateRouteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRouteTemplateMutation, UpdateRouteTemplateMutationVariables>(UpdateRouteTemplateDocument, options);
      }
export type UpdateRouteTemplateMutationHookResult = ReturnType<typeof useUpdateRouteTemplateMutation>;
export type UpdateRouteTemplateMutationResult = Apollo.MutationResult<UpdateRouteTemplateMutation>;
export type UpdateRouteTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateRouteTemplateMutation, UpdateRouteTemplateMutationVariables>;
export const DeleteRouteTemplateDocument = gql`
    mutation deleteRouteTemplate($id: bigint!) {
  delete_route_templates_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteRouteTemplateMutationFn = Apollo.MutationFunction<DeleteRouteTemplateMutation, DeleteRouteTemplateMutationVariables>;

/**
 * __useDeleteRouteTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteRouteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRouteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRouteTemplateMutation, { data, loading, error }] = useDeleteRouteTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRouteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRouteTemplateMutation, DeleteRouteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRouteTemplateMutation, DeleteRouteTemplateMutationVariables>(DeleteRouteTemplateDocument, options);
      }
export type DeleteRouteTemplateMutationHookResult = ReturnType<typeof useDeleteRouteTemplateMutation>;
export type DeleteRouteTemplateMutationResult = Apollo.MutationResult<DeleteRouteTemplateMutation>;
export type DeleteRouteTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteRouteTemplateMutation, DeleteRouteTemplateMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/routeTemplateMutations.gql}
 */
export async function deleteRouteTemplate(
  variables: DeleteRouteTemplateMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<DeleteRouteTemplateMutation['delete_route_templates_by_pk']>
export async function deleteRouteTemplate(
  variables: DeleteRouteTemplateMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<DeleteRouteTemplateMutation>
export async function deleteRouteTemplate(
  variables: DeleteRouteTemplateMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<DeleteRouteTemplateMutation['delete_route_templates_by_pk'] | DeleteRouteTemplateMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<DeleteRouteTemplateMutation>(
    DeleteRouteTemplateDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.delete_route_templates_by_pk
}

/**
 * @source {@link src/features/partsDelivery/queries/routeTemplateMutations.gql}
 */
export async function insertRouteTemplate(
  variables: InsertRouteTemplateMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<InsertRouteTemplateMutation['insert_route_templates_one']>
export async function insertRouteTemplate(
  variables: InsertRouteTemplateMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<InsertRouteTemplateMutation>
export async function insertRouteTemplate(
  variables: InsertRouteTemplateMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<InsertRouteTemplateMutation['insert_route_templates_one'] | InsertRouteTemplateMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<InsertRouteTemplateMutation>(
    InsertRouteTemplateDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_route_templates_one
}

/**
 * @source {@link src/features/partsDelivery/queries/routeTemplateMutations.gql}
 */
export async function updateRouteTemplate(
  variables: UpdateRouteTemplateMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateRouteTemplateMutation['update_route_templates_by_pk']>
export async function updateRouteTemplate(
  variables: UpdateRouteTemplateMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateRouteTemplateMutation>
export async function updateRouteTemplate(
  variables: UpdateRouteTemplateMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateRouteTemplateMutation['update_route_templates_by_pk'] | UpdateRouteTemplateMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateRouteTemplateMutation>(
    UpdateRouteTemplateDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_route_templates_by_pk
}